import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import OtherSettingsStore from 'Stores/otherSettingsStore';
import 'Styles/otherSettings/LogsSubdirectoriesModal.scss';
import IconsContainer from "Utils/IconsContainer";
import LoadView from "Components/Common/loadView";
import PaginationV2 from 'Components/Common/Table/PaginationV2';
import Popup from 'Components/Common/popup';
import AppStore from 'Stores/AppStore';
import UsersStore from 'Stores/usersStore';

class LogsSubdirectoriesModal extends Component {

    componentDidUpdate(prevProps, prevState, snapshot) {
        OtherSettingsStore.clientLogsTableStore.HandleComponentDidUpdate(this.directoryInfosContainerNode, () => OtherSettingsStore.GetClientLogsSubDirectoriesList());
    }

    render() {
        if (OtherSettingsStore.clientLogsInfosLoading)
            return <LoadView />;

        if (OtherSettingsStore.clientLogsInfos.length == 0)
            return (
                <div className='placeHolder'>В указанной папке отсутствуют клиентские логи</div>
            );

        return (
            <div className='LogsSubdirectoriesModal-main-container'>
                <div className='directory-search-container'>
                    <div className='directory-search-input-container'>
                        <input
                            className='directory-search-input'
                            onChange={(e) => OtherSettingsStore.clientLogsSubDirectoriesListFilter.searchText = e.target.value}
                            placeholder='Введите ФИО или код устройства пользователя'
                            value={OtherSettingsStore.clientLogsSubDirectoriesListFilter.searchText} />
                        <div className={`directory-search-clear-container ${(OtherSettingsStore.clientLogsSubDirectoriesListFilter.searchText?.length > 0) == true ? "" : "hidden"}`}
                            onClick={_ => {
                                OtherSettingsStore.clientLogsSubDirectoriesListFilter.searchText = "";
                                OtherSettingsStore.GetClientLogsSubDirectoriesList();
                            }}>
                            {IconsContainer.Get('ci-cross')}
                        </div>
                    </div>
                    <button
                        className='directory-search-button'
                        onClick={() => {
                            OtherSettingsStore.clientLogsTableStore.currentPage = 1;
                            OtherSettingsStore.GetClientLogsSubDirectoriesList();
                        }}
                    >
                        Поиск
                    </button>
                </div>
                <div
                    ref={node => this.directoryInfosContainerNode = node}
                    className='directory-infos-container overflowing-element'>
                    {
                        OtherSettingsStore.clientLogsInfos.flatMap(clientLogsUserInfo => {
                            let userState = clientLogsUserInfo.user.state;
                            let notActive = AppStore.isMeeting
                                ? userState?.blockedReasons?.meetingNotActive
                                : userState?.blockedReasons?.docNotActive;
                            return [
                                (
                                    <div className='directory smr-table-line' key={clientLogsUserInfo.user.id}>
                                        <div className='directory-title-content'>
                                            <div className={`user-not-active-icon-container ${notActive ? '' : 'hidden'}`}>
                                                <Popup popupText="Пользователь не активирован"                                                    >
                                                    <div className="user-not-active-icon" />
                                                </Popup>
                                            </div>
                                            <div className='directory-title'>
                                                {clientLogsUserInfo.user.userName}
                                            </div>
                                        </div>
                                        <button
                                            className={clientLogsUserInfo.directoriesInfos.length == 0 ? 'disabled' : ""}
                                            onClick={e => {
                                                if (OtherSettingsStore.clientLogsUserIdOpened != clientLogsUserInfo.user.id)
                                                    OtherSettingsStore.clientLogsUserIdOpened = clientLogsUserInfo.user.id;
                                                else
                                                    OtherSettingsStore.clientLogsUserIdOpened = null;
                                            }}
                                        >
                                            {OtherSettingsStore.clientLogsUserIdOpened != clientLogsUserInfo.user.id ? "Показать" : "Скрыть"}
                                        </button>
                                    </div>
                                )
                            ].concat(
                                OtherSettingsStore.clientLogsUserIdOpened != clientLogsUserInfo.user.id
                                    ? []
                                    : clientLogsUserInfo.directoriesInfos.map(clientLogsDirectoryInfo => (
                                        <div className='directory smr-table-line' key={clientLogsDirectoryInfo.deviceCode}>
                                            <div className='directory-title-content'>
                                                {IconsContainer.Get('ci-folder-icon')}
                                                <div className='directory-title'>
                                                    {clientLogsDirectoryInfo.directoryDisplayName}
                                                </div>
                                            </div>
                                            <button
                                                onClick={e => UsersStore.ExportClientLogs(clientLogsDirectoryInfo.directoryName)}>
                                                Выгрузить
                                            </button>
                                        </div>
                                    )
                                    )
                            );
                        })
                    }
                </div>
                <PaginationV2
                    pageCount={OtherSettingsStore.clientLogsTableStore.pageCount}
                    currentPage={OtherSettingsStore.clientLogsTableStore.currentPage}
                    setCurrentPage={val => {
                        OtherSettingsStore.clientLogsTableStore.currentPage = val;
                        OtherSettingsStore.GetClientLogsSubDirectoriesList();
                    }}
                />
            </div>
        );
    }
}

export default observer(LogsSubdirectoriesModal);